import styled from 'styled-components';
import { COLOURS, FONT_WEIGHT, isFocused, media } from '@belong/themes';
import withLink from '../../hocs/withLink';
import { Icon } from '../../Icon';
import { ListItem as BaseListItem } from '../../styles/List';

export const ListItem = styled(BaseListItem)`
  border-bottom: 1px solid ${COLOURS.GREY_300};
  &:last-child {
    border-bottom: none;
  }
`;

/**
 * Single flat grid — everything in row 1 (icon, label, status, chevron) shares
 * the same row so align-items: center keeps them all on the same baseline
 * regardless of individual heights. Body content sits in row 2 under the label
 * and status columns only, so it never affects row 1 alignment.
 *
 * column-gap is intentionally 0; each item applies its own margin so that
 * absent items (no icon, no status) leave no phantom gap.
 */
export const LinkGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  grid-template-areas:
    'icon  label  status  chevron'
    '.     body   body    .      ';
  align-items: center;
`;

export const Label = styled.span`
  display: block;
  color: ${COLOURS.DARK_BLUE};
  grid-area: label;
`;

export const StatusWrapper = styled.div`
  grid-area: status;
  margin-left: 1.6rem;

  ${media('sm')`
    margin-left: 2.4rem;
  `}

  ${media('xl')`
    margin-left: 3.2rem;
  `}
`;

export const BodyContent = styled.div`
  grid-area: body;
  display: flex;
  flex-direction: column;
  margin-top: 0.4rem;
  gap: 1.2rem;

  /* Collapse entirely when empty so the empty row and its margin-top
     don't add height that would push row 1 items off-centre. */
  &:empty {
    display: none;
  }

  ${media('sm')`
    gap: 1.6rem;
  `}
`;

export const RightIcon = styled(Icon)`
  grid-area: chevron;
  margin-left: 1.6rem;
`;

export const StyledIcon = styled(Icon)`
  grid-area: icon;
  color: ${COLOURS.DARK_BLUE};
  text-align: center;
  margin-right: 0.8rem;
`;

export const Link = withLink(styled.a`
  display: block;
  padding: 1.6rem 0;
  text-decoration: none;
  width: 100%;
  color: ${COLOURS.GREY_600};
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};
  line-height: 2.4rem;
  font-size: inherit;
  letter-spacing: 0px;
  cursor: pointer;

  ${media('xl')`
    padding: 2rem 0;
  `}

  &:hover {
    ${Label} {
      color: ${COLOURS.DARK_BLUE};
      text-decoration: underline;
    }
  }
  &:focus {
    ${isFocused()};
    svg {
      color: ${COLOURS.DARK_BLUE};
    }
  }
`);
